import React from "react";
import { createPortal } from "react-dom";
import { MessageSquare } from "lucide-react";
import { useChat } from "../../contexts/ChatContext";

export const TeamChatLauncher = () => {
  const { isOpen, setIsOpen, unreadCount } = useChat();

  if (isOpen) return null;

  return createPortal(
    <button
      type="button"
      onClick={() => setIsOpen(true)}
      className="fixed right-6 bottom-6 z-[9999] w-14 h-14 rounded-full bg-blue-600 hover:bg-blue-700 active:bg-blue-800 text-white shadow-xl hover:shadow-2xl flex items-center justify-center transition-all duration-200 hover:scale-105 active:scale-95 focus:outline-none focus:ring-4 focus:ring-blue-500/30 cursor-pointer border border-white/20 select-none font-sans"
      title="Team chat"
      aria-label="Open Team chat"
    >
      <MessageSquare className="w-6 h-6 text-white stroke-[2.2]" />
      {unreadCount > 0 && (
        <span className="absolute -top-1 -right-1 min-w-[20px] h-5 px-1 bg-red-500 text-white text-[11px] font-bold rounded-full flex items-center justify-center ring-2 ring-white dark:ring-slate-900 shadow-sm animate-pulse font-sans">
          {unreadCount > 99 ? "99+" : unreadCount}
        </span>
      )}
    </button>,
    document.body
  );
};
